export const MIXPANEL_EVENTS = {
	SIGNUP: {
		PAGE_VIEWED: "SHARE_QUESTIONAIRE/SIGNUP_PAGE_VIEWED",
		OTP_REQUESTED: "SHARE_QUESTIONAIRE/OTP_REQUESTED",
		OTP_VERIFIED: "SHARE_QUESTIONAIRE/OTP_VERIFIED",
		PASSPORT_UPLOADED: "SHARE_QUESTIONAIRE/PASSPORT_UPLOADED"
	},
	QUESTIONNAIRE: {
		PAGE_VIEWED: "SHARE_QUESTIONAIRE/QUESTIONNAIRE_PAGE_VIEWED",
		ANSWER_SUBMITTED: "SHARE_QUESTIONAIRE/ANSWER_SUBMITTED",
		DOCUMENT_UPLOADED: "SHARE_QUESTIONAIRE/DOCUMENT_UPLOADED",
		QUESTIONNAIRE_SUBMITTED: "SHARE_QUESTIONAIRE/QUESTIONNAIRE_SUBMITTED"
	},
	EDC_FLOW: {
		SCREEN_VIEWED: "SHARE_QUESTIONAIRE/EDC_SCREEN_VIEWED",
		CONTINUE_CLICKED: "SHARE_QUESTIONAIRE/EDC_CONTINUE_CLICKED",
		DOCUMENT_UPLOADED: "SHARE_QUESTIONAIRE/EDC_DOCUMENT_UPLOADED",
		AUTO_FIX_APPLIED: "SHARE_QUESTIONAIRE/EDC_AUTO_FIX_APPLIED",
		TNC_ACCEPTED: "SHARE_QUESTIONAIRE/EDC_TNC_ACCEPTED",
		FORM_ANSWER_UPDATED: "SHARE_QUESTIONAIRE/EDC_FORM_ANSWER_UPDATED",
		FORM_SUBMITTED: "SHARE_QUESTIONAIRE/EDC_FORM_SUBMITTED"
	}
} as const;

